var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6082_1373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3845 8.51013L6.19878 8.5C3.14961 8.5 0.613168 11.4763 0.533608 15.302C0.531714 15.4041 0.599277 15.4883 0.682625 15.4891L11.8684 15.4977V15.5C14.9175 15.5 17.454 12.5237 17.5335 8.69795C17.5354 8.59586 17.4679 8.51169 17.3845 8.51091V8.51013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3823 0.507237L6.28151 0.5C3.18782 0.5 0.61433 2.62592 0.533609 5.35861C0.531687 5.43153 0.600236 5.49165 0.684802 5.49221L17.7856 5.49833V5.5C20.8793 5.5 23.4528 3.37408 23.5335 0.641394C23.5355 0.56847 23.4669 0.50835 23.3823 0.507793V0.507237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48292 23.1466C5.95244 22.5379 6.65028 20.8531 6.04158 19.3836C5.43289 17.9141 3.74816 17.2163 2.27864 17.825C0.809124 18.4337 0.111288 20.1184 0.719983 21.5879C1.32868 23.0574 3.0134 23.7553 4.48292 23.1466Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6082_1373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlare);
export default __webpack_public_path__ + "static/media/flare.5a7aa92d4bd1cc125b325193ee95d5fe.svg";
export { ForwardRef as ReactComponent };